import gsap from "gsap";

export default class TabController {
    constructor() {
        this.tabs = document.querySelectorAll('.js-tab');
        this.tabsContent = document.querySelectorAll('.js-tab-content');
        this.tabContentWrapper = document.querySelector('.js-tab-content-wrapper');

        if (!this.tabs && !this.tabsContent) {
            return;
        }

        this.init();
    }

    init() {
        for (let i = 0; i < this.tabs.length; i++) {
            let tab = this.tabs[i];
            this.controller(tab, i);
        }
    }

    controller(tab, current) {
        tab.addEventListener('click', () => {
            if(this.tabContentWrapper !== null){
            gsap.to(this.tabContentWrapper, 0.3, {
                height: 0,
            });
            }

            for (let tab of this.tabs) {
                tab.classList.remove("is-active");
            }
            tab.classList.add("is-active");

            for (let i = 0; i < this.tabsContent.length; i++) {
                this.tabsContent[i].style.display = (current === i) ? "flex" : "none";
            }

            if(this.tabContentWrapper !== null) {
                gsap.set(this.tabContentWrapper, {
                    height: "auto",
                    delay: 0.2,
                    onComplete: () => {
                        let contentHeight;
                        contentHeight = this.tabContentWrapper.clientHeight;
                        gsap.set(this.tabContentWrapper, {
                            height: 0,
                            onComplete: () => {
                                gsap.to(this.tabContentWrapper, 0.3, {
                                    height: contentHeight,
                                    onComplete: () => {
                                        gsap.set(this.tabContentWrapper, {
                                            height: "auto"
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }


        })
    }
}
